'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var waterfall = require('async/waterfall');

var reject = require('async/reject');

var each = require('async/each');

var series = require('async/series');

var map = require('async/map');

var WantManager = require('./want-manager');

var Network = require('./network');

var DecisionEngine = require('./decision-engine');

var Notifications = require('./notifications');

var logger = require('./utils').logger;

var Stats = require('./stats');

var defaultOptions = {
  statsEnabled: false,
  statsComputeThrottleTimeout: 1000,
  statsComputeThrottleMaxQueueSize: 1000
};
var statsKeys = ['blocksReceived', 'dataReceived', 'dupBlksReceived', 'dupDataReceived', 'blocksSent', 'dataSent', 'providesBufferLength', 'wantListLength', 'peerCount'];
/**
 * JavaScript implementation of the Bitswap 'data exchange' protocol
 * used by IPFS.
 *
 * @param {Libp2p} libp2p
 * @param {Blockstore} blockstore
 */

var Bitswap =
/*#__PURE__*/
function () {
  function Bitswap(libp2p, blockstore, options) {
    _classCallCheck(this, Bitswap);

    this._libp2p = libp2p;
    this._log = logger(this.peerInfo.id);
    this._options = Object.assign({}, defaultOptions, options); // stats

    this._stats = new Stats(statsKeys, {
      enabled: this._options.statsEnabled,
      computeThrottleTimeout: this._options.statsComputeThrottleTimeout,
      computeThrottleMaxQueueSize: this._options.statsComputeThrottleMaxQueueSize
    }); // the network delivers messages

    this.network = new Network(libp2p, this, {}, this._stats); // local database

    this.blockstore = blockstore;
    this.engine = new DecisionEngine(this.peerInfo.id, blockstore, this.network, this._stats); // handle message sending

    this.wm = new WantManager(this.peerInfo.id, this.network, this._stats);
    this.notifications = new Notifications(this.peerInfo.id);
  }

  _createClass(Bitswap, [{
    key: "_receiveMessage",
    // handle messages received through the network
    value: function _receiveMessage(peerId, incoming, callback) {
      var _this = this;

      this.engine.messageReceived(peerId, incoming, function (err) {
        if (err) {
          // Only logging the issue to process as much as possible
          // of the message. Currently `messageReceived` does not
          // return any errors, but this could change in the future.
          _this._log('failed to receive message', incoming);
        }

        if (incoming.blocks.size === 0) {
          return callback();
        }

        var blocks = Array.from(incoming.blocks.values()); // quickly send out cancels, reduces chances of duplicate block receives

        var toCancel = blocks.filter(function (b) {
          return _this.wm.wantlist.contains(b.cid);
        }).map(function (b) {
          return b.cid;
        });

        _this.wm.cancelWants(toCancel);

        each(blocks, function (b, cb) {
          return _this._handleReceivedBlock(peerId, b, cb);
        }, callback);
      });
    }
  }, {
    key: "_handleReceivedBlock",
    value: function _handleReceivedBlock(peerId, block, callback) {
      var _this2 = this;

      this._log('received block');

      waterfall([function (cb) {
        return _this2.blockstore.has(block.cid, cb);
      }, function (has, cb) {
        _this2._updateReceiveCounters(peerId.toB58String(), block, has);

        if (has) {
          return cb();
        }

        _this2._putBlock(block, cb);
      }], callback);
    }
  }, {
    key: "_updateReceiveCounters",
    value: function _updateReceiveCounters(peerId, block, exists) {
      this._stats.push(peerId, 'blocksReceived', 1);

      this._stats.push(peerId, 'dataReceived', block.data.length);

      if (exists) {
        this._stats.push(peerId, 'dupBlksReceived', 1);

        this._stats.push(peerId, 'dupDataReceived', block.data.length);
      }
    } // handle errors on the receiving channel

  }, {
    key: "_receiveError",
    value: function _receiveError(err) {
      this._log.error('ReceiveError: %s', err.message);
    } // handle new peers

  }, {
    key: "_onPeerConnected",
    value: function _onPeerConnected(peerId) {
      this.wm.connected(peerId);
    } // handle peers being disconnected

  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(peerId) {
      this.wm.disconnected(peerId);
      this.engine.peerDisconnected(peerId);

      this._stats.disconnected(peerId);
    }
  }, {
    key: "_putBlock",
    value: function _putBlock(block, callback) {
      var _this3 = this;

      this.blockstore.put(block, function (err) {
        if (err) {
          return callback(err);
        }

        _this3.notifications.hasBlock(block);

        _this3.network.provide(block.cid, function (err) {
          if (err) {
            _this3._log.error('Failed to provide: %s', err.message);
          }
        });

        _this3.engine.receivedBlocks([block.cid]);

        callback();
      });
    }
  }, {
    key: "enableStats",
    value: function enableStats() {
      this._stats.enable();
    }
  }, {
    key: "disableStats",
    value: function disableStats() {
      this._stats.disable();
    }
    /**
     * Return the current wantlist for a given `peerId`
     *
     * @param {PeerId} peerId
     * @returns {Wantlist}
     */

  }, {
    key: "wantlistForPeer",
    value: function wantlistForPeer(peerId) {
      return this.engine.wantlistForPeer(peerId);
    }
    /**
     * Return ledger information for a given `peerId`
     *
     * @param {PeerId} peerId
     * @returns {?Object}
     */

  }, {
    key: "ledgerForPeer",
    value: function ledgerForPeer(peerId) {
      return this.engine.ledgerForPeer(peerId);
    }
    /**
     * Fetch a given block by cid. If the block is in the local
     * blockstore it is returned, otherwise the block is added to the wantlist and returned once another node sends it to us.
     *
     * @param {CID} cid
     * @param {function(Error, Block)} callback
     * @returns {void}
     */

  }, {
    key: "get",
    value: function get(cid, callback) {
      this.getMany([cid], function (err, blocks) {
        if (err) {
          return callback(err);
        }

        if (blocks && blocks.length > 0) {
          callback(null, blocks[0]);
        } else {
          // when a unwant happens
          callback();
        }
      });
    }
    /**
     * Fetch a a list of blocks by cid. If the blocks are in the local
     * blockstore they are returned, otherwise the blocks are added to the wantlist and returned once another node sends them to us.
     *
     * @param {Array<CID>} cids
     * @param {function(Error, Blocks)} callback
     * @returns {void}
     */

  }, {
    key: "getMany",
    value: function getMany(cids, callback) {
      var _this4 = this;

      var pendingStart = cids.length;
      var wantList = [];
      var promptedNetwork = false;

      var getFromOutside = function getFromOutside(cid, cb) {
        wantList.push(cid);

        _this4.notifications.wantBlock(cid, // called on block receive
        function (block) {
          _this4.wm.cancelWants([cid]);

          cb(null, block);
        }, // called on unwant
        function () {
          _this4.wm.cancelWants([cid]);

          cb(null, undefined);
        });

        if (!pendingStart) {
          _this4.wm.wantBlocks(wantList);
        }
      };

      map(cids, function (cid, cb) {
        waterfall([function (cb) {
          return _this4.blockstore.has(cid, cb);
        }, function (has, cb) {
          pendingStart--;

          if (has) {
            if (!pendingStart) {
              _this4.wm.wantBlocks(wantList);
            }

            return _this4.blockstore.get(cid, cb);
          }

          if (!promptedNetwork) {
            promptedNetwork = true;

            _this4.network.findAndConnect(cids[0], function (err) {
              if (err) {
                _this4._log.error(err);
              }
            });
          } // we don't have the block here


          getFromOutside(cid, cb);
        }], cb);
      }, callback);
    } // removes the given cids from the wantlist independent of any ref counts

  }, {
    key: "unwant",
    value: function unwant(cids) {
      var _this5 = this;

      if (!Array.isArray(cids)) {
        cids = [cids];
      }

      this.wm.unwantBlocks(cids);
      cids.forEach(function (cid) {
        return _this5.notifications.unwantBlock(cid);
      });
    } // removes the given keys from the want list

  }, {
    key: "cancelWants",
    value: function cancelWants(cids) {
      if (!Array.isArray(cids)) {
        cids = [cids];
      }

      this.wm.cancelWants(cids);
    }
    /**
     * Put the given block to the underlying blockstore and
     * send it to nodes that have it in their wantlist.
     *
     * @param {Block} block
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "put",
    value: function put(block, callback) {
      var _this6 = this;

      this._log('putting block');

      waterfall([function (cb) {
        return _this6.blockstore.has(block.cid, cb);
      }, function (has, cb) {
        if (has) {
          return cb();
        }

        _this6._putBlock(block, cb);
      }], callback);
    }
    /**
     * Put the given blocks to the underlying blockstore and
     * send it to nodes that have it them their wantlist.
     *
     * @param {Array<Block>} blocks
     * @param {function(Error)} callback
     * @returns {void}
     */

  }, {
    key: "putMany",
    value: function putMany(blocks, callback) {
      var _this7 = this;

      waterfall([function (cb) {
        return reject(blocks, function (b, cb) {
          _this7.blockstore.has(b.cid, cb);
        }, cb);
      }, function (newBlocks, cb) {
        return _this7.blockstore.putMany(newBlocks, function (err) {
          if (err) {
            return cb(err);
          }

          newBlocks.forEach(function (block) {
            _this7.notifications.hasBlock(block);

            _this7.engine.receivedBlocks([block.cid]);

            _this7.network.provide(block.cid, function (err) {
              if (err) {
                _this7._log.error('Failed to provide: %s', err.message);
              }
            });
          });
          cb();
        });
      }], callback);
    }
    /**
     * Get the current list of wants.
     *
     * @returns {Iterator<WantlistEntry>}
     */

  }, {
    key: "getWantlist",
    value: function getWantlist() {
      return this.wm.wantlist.entries();
    }
    /**
     * Get the current list of partners.
     *
     * @returns {Array<PeerId>}
     */

  }, {
    key: "peers",
    value: function peers() {
      return this.engine.peers();
    }
    /**
     * Get stats about the bitswap node.
     *
     * @returns {Object}
     */

  }, {
    key: "stat",
    value: function stat() {
      return this._stats;
    }
    /**
     * Start the bitswap node.
     *
     * @param {function(Error)} callback
     *
     * @returns {void}
     */

  }, {
    key: "start",
    value: function start(callback) {
      var _this8 = this;

      series([function (cb) {
        return _this8.wm.start(cb);
      }, function (cb) {
        return _this8.network.start(cb);
      }, function (cb) {
        return _this8.engine.start(cb);
      }], callback);
    }
    /**
     * Stop the bitswap node.
     *
     * @param {function(Error)} callback
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop(callback) {
      var _this9 = this;

      this._stats.stop();

      series([function (cb) {
        return _this9.wm.stop(cb);
      }, function (cb) {
        return _this9.network.stop(cb);
      }, function (cb) {
        return _this9.engine.stop(cb);
      }], callback);
    }
  }, {
    key: "peerInfo",
    get: function get() {
      return this._libp2p.peerInfo;
    }
  }]);

  return Bitswap;
}();

module.exports = Bitswap;